import * as React from "react";
import {Box, Typography} from "@mui/material";

type Props = {
    icon?: JSX.Element,
    title: string,
    /**
     * Follows the title after a bullet, in regular weight — the topbar's own
     * slot for a status, which is not part of the page's name.
     */
    details?: string,
    /** Rendered flush right, for the action that moves the page on. */
    action?: React.ReactNode
}

export function PageHeader({icon, title, details, action}: Props) {
    return <Box sx={{
        backgroundColor: 'var(--color-black80)',
        color: 'var(--color-white)',
        minHeight: '56px',
        padding: '8px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        // below @layout-lg the Angular shell shows its own md-toolbar[hide-gt-md] carrying
        // the sidenav handle and the very same title, so this one would only repeat it
        '@media (max-width: 1279px)': {
            display: 'none'
        }
    }}>
        {icon}
        <Typography sx={icon ? {marginLeft: "10px"}: undefined}>{title}</Typography>
        {details && <Typography sx={{opacity: 0.7}}>• {details}</Typography>}
        {action && <Box sx={{marginLeft: 'auto'}}>{action}</Box>}
    </Box>;
}
